// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2s-3";
export var dialog = "_2s-0";
export var divClassnameSwatch = "_2s-8";
export var flexSwatch = "_2s-4";
export var header = "_2s-1";
export var styleAttributeSwatch = "_2s-7";
export var swatch = "_2s-2";
export var textHeaderSwatch = "_2s-5";
export var webSwatch = "_2s-6";